// Host info is fetched once and shared via HostInfoProvider — this re-export keeps existing
// `app/shared/hooks/use-sdk-host-info` consumers working while the state lives in the context.
export { useSdkHostInfo } from 'app/shared/contexts/host-info';
